var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity } from '@decahedron/entity';
var BetaFeature = /** @class */ (function (_super) {
    __extends(BetaFeature, _super);
    function BetaFeature() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isEnrolled = false;
        _this.isChanged = false;
        _this.description = null;
        _this.documentationUrl = null;
        _this.flagKey = null;
        _this.id = null;
        _this.name = null;
        _this.stage = null;
        return _this;
    }
    BetaFeature.prototype.toggleBeta = function () {
        this.isEnrolled = !this.isEnrolled;
        this.isChanged = true;
    };
    return BetaFeature;
}(Entity));
export { BetaFeature };
